
import React from 'react';

import { NavLink, useLocation } from 'react-router-dom';
import { navigation } from '../../app-navigation';
import { useOpenPages } from '../../contexts/open-pages';
import { useScreenSize } from '../../utils/media-query';

import { AppHeader, SideNavigationMenu, AppFooter } from '../../components';

import type { SideNavToolbarProps } from '../../types';

import './side-nav-outer-toolbar.scss';

export const SideNavOuterToolbar = ({ title, children }: React.PropsWithChildren<SideNavToolbarProps>) => {
  const { isSmall, isXSmall } = useScreenSize();
  const compact = isSmall || isXSmall;
  const { pages } = useOpenPages();
  const { pathname } = useLocation();
  return (
    <div className='side-nav-outer-toolbar'>
      <AppHeader className='layout-header' title={title} />
      {compact && <details className='mobile-open-pages' key={pathname}>
        <summary><span className='dx-icon dx-icon-folder' aria-hidden='true' /><span>Trang đang mở</span><span className='open-pages-count'>{pages.length}</span></summary>
        <SideNavigationMenu />
      </details>}
      <div className='workspace-body layout-body'>
        {!compact && <aside className='workspace-sidebar' aria-label='Trang đang mở'><SideNavigationMenu /></aside>}
        <div className='content'>
          {React.Children.map(children, (item) => {
            return React.isValidElement(item) && item.type !== AppFooter && item;
          })}
        </div>
      </div>
      {compact && <nav className='mobile-bottom-nav' aria-label='Điều hướng chính'>
        {navigation.map(item => {
          const active = pathname === item.path || pathname.startsWith(`${item.path}-`);
          return <NavLink key={item.path} to={item.path} className={active ? 'active' : ''} aria-current={active ? 'page' : undefined}>
            <span className={`dx-icon dx-icon-${item.icon}`} aria-hidden='true' />
            <span>{item.shortText}</span>
          </NavLink>;
        })}
      </nav>}
    </div>
  );
};
